export const ICONS = {
	ANGLE_DOUBLE:
		process.env.PUBLIC_URL + '/media/svg/icons/Navigation/Angle-double-left.svg' ||
		'/saoc-module-web/media/svg/icons/Navigation/Angle-double-left.svg',
	TRASH:
		process.env.PUBLIC_URL + '/media/svg/icons/Home/Trash.svg' ||
		'/saoc-module-web/media/svg/icons/Home/Trash.svg',
	FILES:
		process.env.PUBLIC_URL + '/media/svg/icons/Files/Selected-file.svg' ||
		'/saoc-module-web/media/svg/icons/Files/Selected-file.svg',
	LOCK:
		process.env.PUBLIC_URL + '/media/svg/icons/Code/Lock-overturning.svg' ||
		'/saoc-module-web/media/svg/icons/Code/Lock-overturning.svg',
	GROUP_FOLDERS:
		process.env.PUBLIC_URL + '/media/svg/icons/Files/Group-folders.svg' ||
		'/saoc-module-web/media/svg/icons/Files/Group-folders.svg',
	USERS:
		process.env.PUBLIC_URL + '/media/svg/icons/General/User.svg' ||
		'/saoc-module-web/media/svg/icons/General/User.svg',
	CODE_WARNING:
		process.env.PUBLIC_URL + '/media/svg/icons/Code/Warning-2.svg' ||
		'/saoc-module-web/media/svg/icons/Code/Warning-2.svg',
	NAVIGATION:
		process.env.PUBLIC_URL + '/media/svg/icons/Navigation/Up-2.svg' ||
		'/saoc-module-web/media/svg/icons/Navigation/Up-2.svg',
	DELETED_FILE:
		process.env.PUBLIC_URL + '/media/svg/icons/Files/Deleted-file.svg' ||
		'/saoc-module-web/media/svg/icons/Files/Deleted-file.svg',
};
